import { BookingSampleData, BookingType, ServiceBookingActionsList } from "../actions/serviceBookingActions";
import { Action } from "../actions/types";


export const serviceBookingReducer = (state: BookingType[] = BookingSampleData, action: Action) => {

    switch (action.type) {

        case ServiceBookingActionsList.ADD_BOOKING: {

            return [...state, action.data]
        }

        case ServiceBookingActionsList.EDIT_BOOKING: {

            const index = state.findIndex(i => i.id === action.id)
            const newState = [...state]

            if (index > -1) {
                newState[index] = {
                    ...action.data,
                    id: action.id
                }
            }
            return newState
        }

        case ServiceBookingActionsList.FETCH_BOOKING: {

            return state
        }

        case ServiceBookingActionsList.DELETE_BOOKING: {
            return state.filter(i => i.id !== action.data.id)

        }

        default: return state
    }

}